import { useMemo } from 'react';
import { makeCopy, type Copy } from '../game/copy';
import { useStore } from '../state/store';

/**
 * The words for the current game variant: the game's own theme while in a
 * game, otherwise the one chosen on the main menu.
 */
export function useThemeId(): string {
  const inGame = useStore((s) => (s.screen.name === 'game' ? s.view?.themeId : undefined));
  const chosen = useStore((s) => s.themeId);
  return inGame ?? chosen;
}

export function useTheme(): Copy {
  const id = useThemeId();
  return useMemo(() => makeCopy(id), [id]);
}
